/* Recharge-backed ESP PDP options. Prices and plan IDs come from live Liquid allocations. */
(() => {
  if (customElements.get('esp-recharge-purchase-options')) return;
  class ESPRechargePurchaseOptions extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-esp-plans]').textContent);
      this.scope = this.closest('product-form') || this.closest('.shopify-section');
      this.section = this.closest('.shopify-section') || this.scope;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.data.currency});
      this.purchase = 'subscription';
      this.querySelectorAll('[data-esp-purchase]').forEach(input => { input.name = `esp-purchase-${this.dataset.productId}`; });
      this.onChange = event => {
        if (event.target.matches('[data-esp-purchase]')) this.purchase = event.target.value;
        if (event.target.matches('[data-esp-plan]')) this.planId = Number(event.target.value);
        this.update();
      };
      this.addEventListener('change', this.onChange);
      this.onVariant = event => {
        const id = Number(event.detail?.variant?.id);
        if (this.data.variants.some(variant => variant.id === id)) this.selectVariant(id);
      };
      window.addEventListener('variant:change', this.onVariant);
      this.onSubmit = () => this.syncForms();
      this.section.addEventListener('submit', this.onSubmit, true);
      this.selectVariant(this.data.selectedVariant);
      const requestedPlan=Number(new URLSearchParams(window.location.search).get('selling_plan'));
      if (this.plans.some(plan => plan.id===requestedPlan)) {
        this.planId=requestedPlan;
        this.update();
      }
    }
    disconnectedCallback() {
      window.removeEventListener('variant:change', this.onVariant);
      this.section?.removeEventListener('submit', this.onSubmit, true);
      this.removeEventListener('change', this.onChange);
      this.initialized = false;
    }
    interval(plan) {
      const option = plan.options.find(option => option.name === 'Order Frequency and Unit');
      const match = (option?.value || '').match(/^(\d+)-(day|week|month|year)$/);
      return match ? { count:Number(match[1]), unit:match[2] } : null;
    }
    selectVariant(id) {
      const previous = this.variant?.plans.find(plan => plan.id === this.planId);
      const oldFrequency = previous && this.interval(previous);
      this.variant = this.data.variants.find(variant => variant.id === id);
      if (!this.variant) return;
      this.plans = this.variant.plans.filter(plan => plan.recurring && plan.price === plan.perDeliveryPrice);
      this.plans.sort((a,b) => {
        const x=this.interval(a), y=this.interval(b);
        return x && y && x.unit===y.unit ? x.count-y.count : 0;
      });
      const equivalent = oldFrequency && this.plans.find(plan => {
        const interval=this.interval(plan);
        return interval?.count===oldFrequency.count && interval?.unit===oldFrequency.unit;
      });
      this.planId = (equivalent || this.plans[0])?.id;
      if (this.variant.requiresPlan) this.purchase = 'subscription';
      this.hidden = !this.plans.length;
      this.querySelector('.esp-sub-onetime').hidden = this.variant.requiresPlan;
      const container = this.querySelector('[data-esp-frequency-options]');
      container.replaceChildren();
      this.plans.forEach(plan => {
        const label=document.createElement('label'); label.className='esp-sub-frequency';
        const input=document.createElement('input'); input.type='radio';
        input.name=`esp-frequency-${this.dataset.productId}`;
        input.value=String(plan.id); input.dataset.espPlan='';
        const interval=this.interval(plan);
        const text=document.createElement('span');
        text.textContent=interval ? `${interval.count} ${interval.unit[0].toUpperCase()+interval.unit.slice(1)} Subscription` : plan.name;
        label.append(input,text); container.append(label);
      });
      this.update();
    }
    update() {
      const plan=this.plans.find(plan => plan.id===this.planId);
      const regular=this.money.format(this.variant.price/100);
      this.querySelector('[data-esp-regular-price]').textContent=regular;
      if (plan) {
        this.querySelector('[data-esp-sub-price]').textContent=this.money.format(plan.price/100);
        this.querySelector('[data-esp-was-price]').textContent=regular;
        this.querySelector('[data-esp-was-price]').hidden=plan.price>=this.variant.price;
        const percentage=Math.round((1-plan.price/this.variant.price)*100);
        this.querySelector('[data-esp-subscribe-label]').textContent=percentage>0 ? `Subscribe and Save ${percentage}%` : 'Subscribe';
      }
      this.querySelectorAll('[data-esp-purchase]').forEach(input => { input.checked=input.value===this.purchase; });
      this.querySelectorAll('[data-esp-plan]').forEach(input => { input.checked=Number(input.value)===this.planId; });
      this.querySelector('.esp-sub-details').hidden=this.purchase!=='subscription';
      const single=this.plans.length===1;
      this.querySelector('.esp-sub-frequencies').hidden=single;
      const description=this.querySelector('[data-esp-description]');
      description.classList.toggle('esp-sub-single',single);
      const interval=plan && this.interval(plan);
      if (single && interval) {
        const unit=interval.unit+(interval.count===1?'':'s');
        description.textContent=/\blamp\b/i.test(this.data.title) ? `Receive lamp replacements every ${interval.count} ${unit}.` : `Ships every ${interval.count} ${unit}.`;
      } else if (this.plans.length===3 && this.plans.every((p,i)=>this.interval(p)?.unit==='month' && this.interval(p)?.count===[3,6,12][i])) {
        description.textContent="Take the guesswork out of replacing your filters. We'll ship you a new one every 3, 6 or 12 months depending on your selection.";
      } else {
        description.textContent='Automatic deliveries at your selected frequency. Skip, reschedule, or cancel anytime.';
      }
      this.syncForms();
      this.updateThemePrice(plan);
    }
    syncForms() {
      const selected=this.purchase==='subscription' && this.plans.some(plan => plan.id===this.planId) ? String(this.planId) : '';
      this.scope.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        let input=form.querySelector('input[name="selling_plan"]');
        if (!input) { input=document.createElement('input'); input.type='hidden'; input.name='selling_plan'; input.dataset.espSellingPlan=''; form.append(input); }
        input.value=selected;
        // One-time purchases send no selling_plan field; recurring purchases send one ID.
        input.disabled=!selected;
        form.querySelectorAll('input[name="selling_plan"]').forEach(other => { if(other!==input) other.disabled=true; });
      });
    }
    updateThemePrice(plan) {
      const price=this.scope.querySelector('.product-price .price');
      if (!price) return;
      const subscribed=this.purchase==='subscription' && plan;
      price.textContent=this.money.format((subscribed?plan.price:this.variant.price)/100);
      let original=price.parentElement.querySelector('.esp-sub-original-price');
      if (!original) { original=document.createElement('span'); original.className='esp-sub-original-price'; price.after(original); }
      original.textContent=this.money.format(this.variant.price/100);
      original.hidden=!subscribed || plan.price>=this.variant.price;
    }
  }
  customElements.define('esp-recharge-purchase-options',ESPRechargePurchaseOptions);
})();
